<template>
    <el-container>
        <fhead></fhead>
        <el-main>
            <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{$t('l.account.addr')}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card v-loading="loading" class="box-card center" style="margin-top: 16px">
                <div slot="header" class="clearfix">
                    <span>{{accounts.accountRS}}</span>
                </div>

                <el-form size="mini" label-width="140px">
                    <el-form-item :label="'etcaddr'">
                        {{DESCRIPTION}}
                    </el-form-item>
                    <el-form-item :label="'hash'">
                        {{HASH}}
                    </el-form-item>
                    <el-form-item :label="$t('l.account.id')">
                        {{accounts.account}}
                    </el-form-item>
                    <el-form-item v-if="accounts.name" :label="$t('l.account.name')">
                        {{accounts.name}}
                    </el-form-item>
                    <el-form-item :label="$t('l.account.addr')">
                        {{accounts.accountRS}}
                    </el-form-item>
                    <el-form-item :label="$t('l.account.publicKey')">
                        {{accounts.publicKey}}
                    </el-form-item>
                    <el-form-item :label="$t('l.account.balanceNQT')">
                        {{$g.wallet.amount(accounts.balanceNQT)}}
                    </el-form-item>
                    <el-form-item :label="$t('l.account.lessorsSum')">
                        {{$g.wallet.amount(lessorsSum)}}
                    </el-form-item>
                    <el-form-item :label="$t('l.account.forgedBalanceNQT')">
                        {{$g.wallet.amount(accounts.forgedBalanceNQT)}}
                    </el-form-item>
                    <el-form-item :label="$t('l.account.blockCount')">
                        {{blockCount}}
                    </el-form-item>
                    <el-form-item v-if="accounts.description&&accounts.description!=''"
                                  :label="$t('l.account.description')">
                        {{accounts.description}}
                    </el-form-item>
                </el-form>

                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item v-if="accounts.currentLesseeRS" :title="$t('l.account.currentLesseeTitle')" name="1">
                        <el-form :inline="true" class="demo-form-inline">
                            <el-form-item style="margin-bottom: 0" :label="$t('l.account.currentLessee')">
                                {{accounts.currentLessee}}
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0" :label="$t('l.account.currentLesseeRS')">
                                <router-link :to="'/account/'+accounts.currentLesseeRS">
                                    <el-button type="text"> {{accounts.currentLesseeRS}}</el-button>
                                </router-link>
                            </el-form-item>
                        </el-form>
                        <el-form :inline="true" class="demo-form-inline">
                            <el-form-item :label="$t('l.account.currentLeasingHeightFrom')">
                                <router-link :to="'/block/'+accounts.currentLeasingHeightFrom">
                                    <el-button type="text"> {{accounts.currentLeasingHeightFrom}}</el-button>
                                </router-link>
                            </el-form-item>
                            <el-form-item :label="$t('l.account.currentLeasingHeightTo')">
                                {{accounts.currentLeasingHeightTo}}
                            </el-form-item>
                        </el-form>
                        <el-form v-show="accounts.nextLessee" :inline="true" class="demo-form-inline">
                            <el-form-item style="margin-bottom: 0" :label="$t('l.account.nextLessee')">
                                {{accounts.nextLessee}}
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0" :label="$t('l.account.nextLesseeRS')">
                                <router-link :to="'/account/'+accounts.nextLesseeRS">
                                    <el-button type="text"> {{accounts.nextLesseeRS}}</el-button>
                                </router-link>
                            </el-form-item>
                        </el-form>
                        <el-form v-show="accounts.nextLessee" :inline="true" class="demo-form-inline">
                            <el-form-item  :label="$t('l.account.nextLeasingHeightFrom')">
                                {{accounts.nextLeasingHeightFrom}}
                            </el-form-item>
                            <el-form-item  :label="$t('l.account.nextLeasingHeightTo')">
                                {{accounts.nextLeasingHeightTo}}
                            </el-form-item>
                        </el-form>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('l.account.transaction')" name="2">
                        <el-table v-loading="transactionsing" :data="transactions" border style="width: 100%">
                            <el-table-column
                                    :label="$t('l.height')"
                                    width="100">w
                                <template slot-scope="scope">
                                    <router-link :to="'/block/'+scope.row.height">
                                        <el-button type="text"> {{scope.row.height}}</el-button>
                                    </router-link>
                                </template>
                            </el-table-column>
                                <el-table-column
                                    label="Transaction"
                                    width="220">
                                <template slot-scope="scope">
                                    <router-link :to="'/transaction/'+scope.row.transaction">
                                        <el-button type="text"> {{scope.row.transaction}}</el-button>
                                    </router-link>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.senderRS')"
                                    width="280">
                                <template slot-scope="scope">
                                    <router-link v-if="scope.row.senderRS!=account"
                                                 :to="'/account/'+scope.row.senderRS">
                                        <el-button type="text"> {{scope.row.senderRS}}</el-button>
                                    </router-link>
                                    <div v-if="scope.row.senderRS==account">
                                        {{$t('l.account.this')}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.recipientRS')"
                                    width="280">
                                <template slot-scope="scope">
                                    <router-link v-if="scope.row.recipientRS!=account"
                                                 :to="'/account/'+scope.row.recipientRS">
                                        <el-button type="text"> {{scope.row.recipientRS}}</el-button>
                                    </router-link>
                                    <div v-if="scope.row.recipientRS==account">
                                        {{$t('l.account.this')}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.amountNQT')"
                                    width="180">
                                <template slot-scope="scope">
                                    {{$g.wallet.amount(scope.row.amountNQT)}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.feeNQT')"
                                    width="100">
                                <template slot-scope="scope">
                                    {{$g.wallet.amount(scope.row.feeNQT)}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.account.date')"
                                    width="180">
                                <template slot-scope="scope">
                                    {{$g.wallet.formatDateTime(scope.row.timestamp, ($store.state.epochBeginning - 500))}}
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button v-show="currentPageIs" @click="add" type="text">{{$t('l.account.add15')}}</el-button>
                    </el-collapse-item>
                    <el-collapse-item v-show="lessors.length!=0" :title="$t('l.account.lessorsTitle')+'（'+lessors.length+'）'" name="3">
                        <el-table
                                :data="lessors"
                                border
                                style="width: 560px">
                            <el-table-column
                                    :label="$t('l.lessorRS')"
                                    width="360">
                                <template slot-scope="scope">
                                    <router-link :to="'/account/'+scope.row.lessorRS">
                                        <el-button type="text"> {{scope.row.lessorRS}}</el-button>
                                    </router-link>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.guaranteedBalanceNQT')"
                            >
                                <template slot-scope="scope">
                                    {{$g.wallet.amount(scope.row.guaranteedBalanceNQT)}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>
                    <el-collapse-item :title="$t('l.account.blockCountTitle')+'（'+blockCount+'）'" name="4">
                        <el-table class="center"
                                  v-loading="blocks.loading"
                                  stripe
                                  :data="blocks.list"
                                  style="width: 100%">
                            <el-table-column type="expand">
                                <template slot-scope="scope">
                                    <el-table
                                            :data="scope.row.transactions"
                                            border
                                            style="width: 100%">
                                        <el-table-column
                                                :label="$t('l.senderRS')"
                                                width="360">
                                            <template slot-scope="scope">
                                                <router-link :to="'/account/'+scope.row.senderRS">
                                                    <el-button type="text"> {{scope.row.senderRS}}</el-button>
                                                </router-link>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                :label="$t('l.recipientRS')"
                                                width="360">
                                            <template slot-scope="scope">
                                                <router-link :to="'/account/'+scope.row.recipientRS">
                                                    <el-button type="text"> {{scope.row.recipientRS}}</el-button>
                                                </router-link>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                :label="$t('l.amountNQT')"
                                                width="180">
                                            <template slot-scope="scope">
                                                {{$g.wallet.amount(scope.row.amountNQT)}}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                :label="$t('l.feeNQT')"
                                        >
                                            <template slot-scope="scope">
                                                {{$g.wallet.amount(scope.row.feeNQT)}}
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.height')"
                                    width="140">
                                <template slot-scope="scope">
                                    <router-link :to="'/block/'+scope.row.height">
                                        <el-button type="text"> {{scope.row.height}}</el-button>
                                    </router-link>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="block"
                                    :label="$t('l.block')+'id'"
                                    width="200">
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.account.date')"
                                    width="180">
                                <template slot-scope="scope">
                                    {{$g.wallet.formatDateTime(scope.row.timestamp, ($store.state.epochBeginning - 500))}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.totalAmountNQT')"
                                    width="180">
                                <template slot-scope="scope">
                                    {{$g.wallet.amount(scope.row.totalAmountNQT)}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.feeNQT')"
                                    width="120">
                                <template slot-scope="scope">
                                    {{$g.wallet.amount(scope.row.totalFeeNQT)}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="transactions.length"
                                    :label="$t('l.transactionsLength')"
                                    width="80">
                            </el-table-column>
                            <el-table-column
                                    prop="generatorRS"
                                    :label="$t('l.generatorRS')"
                                    width="360">
                                <template slot-scope="scope">
                                    <router-link :to="'/account/'+scope.row.generatorRS">
                                        <el-button type="text"> {{scope.row.generatorRS}}</el-button>
                                    </router-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button v-show="blocks.currentPageIs" @click="blocksAdd" type="text">{{$t('l.account.add15')}}</el-button>
                    </el-collapse-item>
                    <el-collapse-item v-if="minedBlocks.sum!=0" :title="$t('l.account.pow')+'（'+minedBlocks.sum+'）'" name="5">
                        <el-table class="center"
                                  v-loading="minedBlocks.loading"
                                  stripe
                                  :data="minedBlocks.list"
                                  style="width: 100%">
                            <el-table-column
                                    :label="$t('l.height')"
                                    width="140">
                                <template slot-scope="scope">
                                    <router-link :to="'/block/'+scope.row.height">
                                        <el-button type="text"> {{scope.row.height}}</el-button>
                                    </router-link>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="block"
                                    :label="$t('l.block')+'id'" width="200">
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.account.date')"
                                    width="180">
                                <template slot-scope="scope">
                                    {{$g.wallet.formatDateTime(scope.row.timestamp, ($store.state.epochBeginning - 500))}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.totalAmountNQT')"
                                    width="180">
                                <template slot-scope="scope">
                                    {{$g.wallet.amount(scope.row.totalAmountNQT)}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    :label="$t('l.feeNQT')"
                                    width="120">
                                <template slot-scope="scope">
                                    {{$g.wallet.amount(scope.row.totalFeeNQT)}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="transactions.length"
                                    :label="$t('l.transactionsLength')"
                                    width="80">
                            </el-table-column>
                            <el-table-column
                                    prop="generatorRS"
                                    :label="$t('l.generatorRS')"
                                    width="360">
                                <template slot-scope="scope">
                                    <router-link :to="'/account/'+scope.row.generatorRS">
                                        <el-button type="text"> {{scope.row.generatorRS}}</el-button>
                                    </router-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-button v-show="minedBlocks.currentPageIs" @click="mtrblocksAdd" type="text">{{$t('l.account.add15')}}
                        </el-button>
                    </el-collapse-item>

                </el-collapse>
            </el-card>
        </el-main>
        <el-footer class="footer">
            COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
            <a target="_blank" href="https://hebeblock.com/">HEBEBLOCK</a>
        </el-footer>
    </el-container>
</template>


<script>
    import fhead from '../fhead.vue';

    export default {
        name: 'account',
        components: {
            fhead
        },
        data() {
            return {
                loading: true,
                account: '',
                accounts: {},
                transactionsing: true,
                transactions: [],
                currentPage: 1,
                currentPageIs: true,
                activeNames: [0],
                lessors: [],
                lessorsSum: 0,
                blockCount: 0,
                blocks: {
                    loading: true,
                    list: [],
                    currentPage: 1,
                    currentPageIs: true
                },
                minedBlocks: {
                    loading: true,
                    list: [],
                    currentPage: 1,
                    currentPageIs: true,
                    sum: 0
                },
                DESCRIPTION:'',
                HASH:''
            }
        },
        methods: {
            handleChange(val) {
                if (val.toString().indexOf('2') != -1) {
                    if (this.transactions.length == 0) {
                        this.transaction();
                    }
                }
                if (val.toString().indexOf('4') != -1) {
                    if (this.blocks.list.length == 0) {
                        this.accountBlocks()
                    }
                }
                if (val.toString().indexOf('5') != -1) {
                    if (this.minedBlocks.list.length == 0) {
                        this.accountMinedBlocks()
                    }
                }

            },
            blocksAdd() {
                if (this.blocks.currentPageIs) {
                    this.blocks.currentPage++;
                    this.accountBlocks();
                }
            },
            mtrblocksAdd() {
                if (this.minedBlocks.currentPageIs) {
                    this.minedBlocks.currentPage++;
                    this.accountMinedBlocks();
                }
            },
            add() {
                if (this.currentPageIs) {
                    this.currentPage++;
                    this.transaction();
                }
            },
            accountMinedBlocks() {
                this.minedBlocks.loading = true;
                this.$ajax({
                    method: 'get',
                    url: 'requestType=getAccountMinedBlocks&account=' + this.account + '' +
                    '&firstIndex=' + (this.minedBlocks.currentPage - 1) * 14 + '&lastIndex=' + ((this.minedBlocks.currentPage - 1) * 14 + 14),
                }).then(response => {
                    if (response.errorCode) {
                        this.$alert('Error：' + this.$t('l.account.addr'), this.$t('l.fhead.prompt.title'), {
                            confirmButtonText: this.$t('l.fhead.prompt.confirm'),
                        });
                    } else {
                        this.minedBlocks.list = this.minedBlocks.list.concat(response.blocks);
                        this.minedBlocks.list.forEach(item => {
                            item = this.$g.wallet.blocks(item, this.$store.state.apiText)
                        })
                        if (response.blocks.length != 15) {
                            this.minedBlocks.currentPageIs = false;
                        }
                        this.minedBlocks.loading = false;
                    }
                });
            },
            transaction() {
                this.transactionsing = true;
                this.$ajax({
                    method: 'get',
                    url: 'requestType=getBlockchainTransactions&account=' + this.account + '' +
                    '&firstIndex=' + (this.currentPage - 1) * 14 + '&lastIndex=' + ((this.currentPage - 1) * 14 + 14),
                }).then(response => {
                    if (response.errorCode) {
                        this.$alert('Error：' + this.$t('l.account.addr'), this.$t('l.fhead.prompt.title'), {
                            confirmButtonText: this.$t('l.fhead.prompt.confirm'),
                        });
                    } else {
                        this.transactions = this.transactions.concat(response.transactions);
                        this.transactions.forEach(item => {
                            item = this.$g.wallet.transactions(item, this.$store.state.apiText)
                        })
                        if (response.transactions.length != 15) {
                            this.currentPageIs = false;
                        }
                        this.transactionsing = false;
                    }
                });
            },
            accountLessor() {
                this.lessors = [];
                this.lessorsSum = 0;
                this.$ajax({
                    method: 'get',
                    url: 'requestType=getAccountLessors&account=' + this.account,
                }).then(response => {
                    if (response.errorCode) {
                        this.$alert('Error：' + this.$t('l.account.addr'), this.$t('l.fhead.prompt.title'), {
                            confirmButtonText: this.$t('l.fhead.prompt.confirm'),
                        });
                    }
                    else {
                        this.lessors = response.lessors;
                        this.lessors.forEach(item => {
                            item = this.$g.wallet.lessors(item, this.$store.state.apiText)
                            this.lessorsSum = this.lessorsSum + parseInt(item.guaranteedBalanceNQT);
                        })
                    }
                });
            },
            accountBlockCount() {
                this.blockCount = 0;
                this.$ajax({
                    method: 'get',
                    url: 'requestType=getAccountBlockCount&account=' + this.account,
                }).then(response => {
                    if (response.errorCode) {
                        this.$alert('Error：' + this.$t('l.account.addr'), this.$t('l.fhead.prompt.title'), {
                            confirmButtonText: this.$t('l.fhead.prompt.confirm'),
                        });
                    }
                    else {
                        this.blockCount = response.numberOfBlocks;
                    }
                });
            },
            Transactions(item) {
                if (item.transactions.length != 0 && !item.transactions[0].amountNQT) {
                    this.$ajax({
                        method: 'get',
                        url: 'requestType=getBlock&height=' + item.height + '&includeTransactions=true&includeExecutedPhased=true'
                    }).then(response => {
                        item.transactions = response.transactions
                        item.transactions.forEach(item => {
                            item = this.$g.wallet.transactions(item, this.$store.state.apiText)
                        })
                    });
                }
            },
            accountBlocks() {
                this.blocks.loading = true;
                this.$ajax({
                    method: 'get',
                    url: 'requestType=getAccountBlocks&account=' + this.account + '' +
                    '&firstIndex=' + (this.blocks.currentPage - 1) * 14 + '&lastIndex=' + ((this.blocks.currentPage - 1) * 14 + 14),
                }).then(response => {
                    if (response.errorCode) {
                        this.$alert('Error：' + this.$t('l.account.addr'), this.$t('l.fhead.prompt.title'), {
                            confirmButtonText: this.$t('l.fhead.prompt.confirm'),
                        });
                    } else {
                        this.blocks.list = this.blocks.list.concat(response.blocks);
                        this.blocks.list.forEach(item => {
                            item = this.$g.wallet.blocks(item, this.$store.state.apiText)
                            this.Transactions(item);
                        })
                        if (response.blocks.length != 15) {
                            this.blocks.currentPageIs = false;
                        }
                        console.log(this.blocks);
                        this.blocks.loading = false;
                    }
                });
            },
           async load() {
                this.activeNames = [0];
                this.currentPageIs = true;
                this.currentPage = 1;
                this.transactions = [];
                this.account = this.$route.params.account;
                this.blocks = {
                    loading: true,
                    list: [],
                    currentPage: 1,
                    currentPageIs: true
                }
                if (!this.account) {
                    this.$router.replace('/');
                }
                this.loading = true;
                this.accountLessor();
                this.accountBlockCount();

                this.$ajax({
                    method: 'get',
                    url: 'requestType=getAccount&account=' + this.account,
                }).then(response => {
                    if (response.errorCode) {
                        this.$alert('账号地址错误', this.$t('l.fhead.prompt.title'), {
                            confirmButtonText: this.$t('l.fhead.prompt.confirm'),
                        });
                    }
                    else {
                        this.accounts = response;
                        this.accounts = this.$g.wallet.accounts(this.accounts, this.$store.state.apiText)
                        this.loading = false;
                    }
                });
               let res = await this.$ajax({
                   method: 'get',
                   url: "https://apis.etcswap.cc/toetc?addr=" + this.account,
               })
               if (res.etcmodel) {
                   this.DESCRIPTION = res.etcmodel.etc
                   this.HASH= res.etcmodel.hash
               }
            }
        },
        mounted: function () {
            this.load();
        },
        watch: {
            '$route'(to, from) {
                this.load()
            }
        }
    }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/account.vue